export class ConversationExcelDetailDto {
  documentName: string;
  includeUserDefinedCategories: boolean;
  includeAIGeneratedCategories: boolean;
  includeAIInsights: boolean;
  selectedAIInsightTypes?: string[];
  includeSentimentValues: boolean;
}
